import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles  } from '@mui/styles';
import moment from 'moment';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { TrackingCtx  } from "../tracking";
import { hidePreferences, editPreferences, savePreferences } from "../actions/preferencesActions";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { Button as ReactButton } from '@mui/material';
import { WithTracking } from "./WithTracking";
import TextField from "@mui/material/TextField";

const Button = WithTracking(ReactButton);

const styles = theme => ({
  root: {
    flexGrow: 1,
    position: 'sticky',
    top: 0,
    zIndex: 500
  },
  flex: {
    flex: 1
  },
  logo: {
    color: theme.palette.common.white,
    fontWeight: 300,
    letterSpacing: 3,
    marginLeft: 20,
    marginRight: 40
  }
});

class Preferences extends Component {
  render() {
    const { dispatch, preferences, classes } = this.props;
    const handleSave = async () => {
      await dispatch(savePreferences(preferences.edit)); 
      window.location.reload();
    }
    const handleCancel =  () => dispatch(hidePreferences());
    const handleMinDateCutoffChange = date => {
        if (date) {
          date = moment(date).isValid() ? date.toISOString() : null;
        }
        dispatch(editPreferences({ ...preferences.edit, minDateCutoff: date}))
    };

    return (
      <TrackingCtx.Provider value={{ category: "preferences", action:"preferences-dialog" }}>
      <div className={classes.root}>
        <Dialog open={true}  onClose={handleCancel} fullWidth >
          <DialogTitle id="alert-dialog-title" >Preferences</DialogTitle>
          <DialogContent>
          <div>
          <LocalizationProvider moment={AdapterMoment}>
            <DatePicker
              onOpen={this.openDatePicker}
              onClose={this.closeDatePicker}
              clearable
              value={preferences.edit.minDateCutoff}
              inputFormat="MM/DD/YYYY"
              fullWidth
              component="span"
              onChange={handleMinDateCutoffChange}
              animateYearScrolling={false}
              label="Filter out data older than"
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
          </div>      
          </DialogContent>
          <DialogActions>
          <Button onClick={handleSave} tracking="save">
            OK
          </Button>
          <Button onClick={handleCancel} tracking="close">
            Cancel
          </Button>
        </DialogActions>
        </Dialog>
      </div>
      </TrackingCtx.Provider>
    );
  }
}


const mapStateToProps = state => {
  return {
    preferences: state.preferencesRequest ||{},
  }
};

export default connect(mapStateToProps)(withStyles(styles)(Preferences));
